import type { RefObject } from 'react';

import SelectModal from '@/components/Select/SelectModal';
import type { SelectOptionT } from '@/components/Select/types';
import {
  type FILTER_OPERATOR,
  filterOperatorDic,
  getFilterOperatorText,
} from '@/types/dataTableConst';

type Props = {
  dropdownKey: string;
  selected: FILTER_OPERATOR;
  multiFilter: boolean;
  multiValue?: boolean;
  onChange?: (value: FILTER_OPERATOR) => void;
  anchorRef: RefObject<HTMLDivElement>;
};

const FilterItemOperatorSelectModal = (props: Props) => {
  const options: SelectOptionT[] = Object.keys(filterOperatorDic).map((key) => {
    const name = getFilterOperatorText({
      operator: key as FILTER_OPERATOR,
      multiFilter: props.multiFilter,
      isMultiValueField: props.multiValue,
    });
    return {
      value: key,
      searchName: name,
    };
  });
  return (
    <SelectModal
      anchorRef={props.anchorRef}
      name={props.dropdownKey}
      data={() => ({
        list: options,
        cursor: null,
      })}
      value={props.selected}
      onSelect={(v) => props.onChange?.(v as FILTER_OPERATOR)}
      width="160px"
      modalOptions={{
        offset: {
          y: 4,
        },
      }}
    />
  );
};

export default FilterItemOperatorSelectModal;
